import { EventEmitter, Type } from '@angular/core';
import { ELearningDashboardStudent, StudentFilterValues } from '../Elearning-Models';


export class FilterService{

    studentFilter: EventEmitter<any> = new EventEmitter<any>();
    activeFilter: any;

    collapseExpandEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(filterState?: number){
        if(!filterState){
            //Null filter state - first time coming to page...
            this.activeFilter = this.showStudentsWithActionItems;
            this.emitActiveFilter();
        } 
        else{
            this.whichFilter(filterState);
        }
    }

    emitFilterState(filterState: number){
        this.whichFilter(filterState);
    }

    private whichFilter(filterState: number) {
        switch (filterState) {
            case StudentFilterValues.All: {
                this.activeFilter = this.showAllStudents;
                this.emitActiveFilter();
                break;
            }
            case StudentFilterValues.NeedsAttention: {
                this.activeFilter = this.showStudentsWithActionItems;
                this.emitActiveFilter();
                break;
            }
        }
    }

    emitActiveFilter(){
        this.studentFilter.emit(this.activeFilter);
    }

    emitAllStudents(){
        this.activeFilter = this.showAllStudents;
        this.emitActiveFilter();
    }

    emitStudentsWithActionItems(){
        this.activeFilter = this.showStudentsWithActionItems;
        this.emitActiveFilter();
    }

    emitNoStudents(){
        this.activeFilter = this.showNoStudents;
        this.emitActiveFilter();
    }

    showNoStudents(students: ELearningDashboardStudent[]){
        return [];
    }

    showAllStudents(students: ELearningDashboardStudent[]){
        return students;
    }

    showStudentsWithActionItems(students: ELearningDashboardStudent[]){
        return students.filter(student => student.NeedsAssignment == true || student.NeedsGradeReleasedCount > 0 || student.NeedsGradingCount > 0);
    }


    /////////////////////////////////////////////////////////////////
    //                     Expand/Collapse                        //

    emitCollapse(){
        this.collapseExpandEmitter.emit(true);
    }

    emitExpand(){
        this.collapseExpandEmitter.emit(false);
    }
}